if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        // DESKTOP: every picture laid out in a grid that fits the window, with a hover preview
        // no bigger than the window (Jonathan, 16/10/2026). Dawn's own stacked, full-width
        // layout made a single picture taller than the screen. Mobile keeps Dawn's behaviour.
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.layoutGrid();
          return;
        }
        this.showActiveMedia();
      }

      hide() {
        this.hidePreview();
        super.hide();
      }

      layoutGrid() {
        const content = this.querySelector('.product-media-modal__content');
        const items = Array.from(content.children).filter((el) => el.matches('img, deferred-media, product-model'));
        items.forEach((el) => el.classList.add('active'));
        // COUNT ONLY WHAT SHOWS: the theme hides other variants' pictures, and sizing the grid
        // for all of them left a few small pictures in a mostly empty pop-up (16/10/2026).
        const shown = items.filter((el) => getComputedStyle(el).display !== 'none');
        const count = Math.max(shown.length, 1);
        const cols = Math.ceil(Math.sqrt(count));
        content.style.setProperty('--dc-cols', cols);
        content.style.setProperty('--dc-rows', Math.ceil(count / cols));
        content.classList.add('dc-media-grid');
        content.classList.toggle('dc-media-grid--single', count === 1);
        content.scrollTop = 0;
        if (count > 1 && !this.dcPreviewBound) this.bindPreview(content);
      }

      bindPreview(content) {
        this.dcPreviewBound = true;
        this.dcPreview = document.createElement('div');
        this.dcPreview.className = 'dc-media-preview';
        this.dcPreview.setAttribute('aria-hidden', 'true');
        this.dcPreview.appendChild(document.createElement('img'));
        this.querySelector('.product-media-modal__dialog').appendChild(this.dcPreview);
        content.addEventListener('mouseover', (event) => {
          const img = event.target.closest('img');
          if (!img || !content.contains(img)) return;
          const shown = this.dcPreview.firstChild;
          shown.srcset = img.srcset;
          shown.sizes = '60vw';
          shown.src = img.currentSrc || img.src;
          shown.alt = '';
          // The preview keeps the picture's own shape, sized to fit in the window.
          this.dcAspect = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1;
          // Never wider than the picture's own pixels - past that it is only blurred.
          this.dcMaxWidth = img.naturalWidth || Infinity;
          // How wide the picture already shows in its grid cell (object-fit: contain).
          const box = img.getBoundingClientRect();
          this.dcShownWidth = Math.min(box.width, box.height * this.dcAspect);
          this.dcPreview.classList.toggle('is-visible', this.placePreview(event));
        });
        content.addEventListener('mousemove', (event) => {
          if (!event.target.closest('img')) return;
          this.dcPreview.classList.toggle('is-visible', this.placePreview(event));
        });
        content.addEventListener('mouseout', (event) => {
          const img = event.target.closest('img');
          if (img && !img.contains(event.relatedTarget)) this.hidePreview();
        });
      }

      // FOLLOWS THE CURSOR (Jonathan, 16/10/2026): a centred preview hid the grid it was
      // previewing. It sits beside the pointer, on whichever side has more room, and is
      // never larger than the window. Answers false - show nothing - when the preview would not
      // be clearly bigger than the picture already on screen (Jonathan, same day: "There's no point").
      placePreview(event) {
        const gap = 24;
        const edge = 12;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const right = event.clientX > vw / 2 ? false : true;
        const room = (right ? vw - event.clientX : event.clientX) - gap - edge;
        let h = Math.min(vh * 0.85, vh - 2 * edge);
        let w = h * this.dcAspect;
        const cap = Math.min(room, this.dcMaxWidth);
        if (w > cap) {
          w = Math.max(cap, 0);
          h = w / this.dcAspect;
        }
        if (w < this.dcShownWidth * 1.15) return false;
        const x = right ? event.clientX + gap : event.clientX - gap - w;
        const y = Math.min(Math.max(event.clientY - h / 2, edge), vh - h - edge);
        Object.assign(this.dcPreview.style, {
          width: Math.round(w) + 'px',
          height: Math.round(h) + 'px',
          transform: 'translate(' + Math.round(x) + 'px, ' + Math.round(y) + 'px)',
        });
        return true;
      }

      hidePreview() {
        if (this.dcPreview) this.dcPreview.classList.remove('is-visible');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
